export const feraConfig = {
    "environment": "production",
    "apiUrl": "https://api.fera.ai/",
    "apiCdnUrl": "https://cdn.fera.ai/api/",
    "cdnUrl": "https://cdn.fera.ai/js/",
    "appUrl": "https://app.fera.ai/",
    "devMode": false, 
    "showErrors": false,
    "wixAppId": "c9064755-5cc8-4faf-a5a6-41a0150a6640"
};
export async function injectFeraFooter({ window, document, element }) {
    // Fera App Embed v2 for development environment
    const jsVersion = 3;
    const baseCdnUrl = `${ feraConfig.cdnUrl }v${ jsVersion }/`;

    if (feraConfig.environment != 'production') window.feraEnvironment = feraConfig.environment;

    if (element.attributes['data-app-instance'] != feraConfig.appInstanceId) feraConfig.appInstanceId = element.attributes['data-app-instance'].value;

    window.fera = window.fera || [];
    window.fera.push("configure", feraConfig);

    if (!(window.fera && !Array.isArray(window.fera)) && !document.querySelector('#fera_js')) {
      const element = document.createElement('script');element.src = `${ baseCdnUrl }fera.js`;element.id = "fera_js";element.async = true; document.body.append(element);
    }
}

export async function setupWidget({ document, window, tempHtml, tempCss, element }) {
    await injectFeraFooter({ window, document, element });

    if (element.attributes['data-fera-needs-setup'] && element.attributes['data-fera-needs-setup'].value === 'true') {
        element.innerHTML = `You're running an older Fera frontend or have not completed your setup. Please contact us via https://help.fera.ai for help.`;
        element.style = `font-size: 4vw; color: red; text-shadow: 1px 1px 2px white;`;
    }

    element.innerHTML = tempHtml;

    const style = document.createElement("style");
    style.innerHTML = tempCss;
    document.body.appendChild(style);
}